// extracted by mini-css-extract-plugin
module.exports = {"job-help-text":"jobs_tab_content__job-help-text___3S_0G","jobHelpText":"jobs_tab_content__job-help-text___3S_0G"};